import { render, staticRenderFns } from "./SInput.vue?vue&type=template&id=0379c22c&scoped=true&"
import script from "./SInput.vue?vue&type=script&lang=ts&"
export * from "./SInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379c22c",
  null
  
)

export default component.exports